import React from 'react'
import { useSelector } from 'react-redux'
import { Badge, Card, Col, Row, Spinner } from 'react-bootstrap'
import { categoryColor } from '../../utils/categoryColor'

function CharityList() {
  const items = useSelector((state) => state.charities.items)
  const loading = useSelector((state) => state.charities.loading)
  const charities = (items ?? [])
    .filter((c) => c.active)
    .sort((a, b) => a.data.category.localeCompare(b.data.category))

  return (
    <section aria-label="Charity List" className="py-4">
      <header className="mb-4">
        <p
          className="text-uppercase fw-semibold text-muted mb-1"
          style={{ fontSize: '0.7rem', letterSpacing: '0.1em' }}
        >
          Supporting These Organizations
        </p>
        <h2 className="display-5 fw-bold mb-3">Charities</h2>
        <hr className="opacity-25" />
      </header>

      {loading ? (
        <div className="d-flex justify-content-center py-5">
          <Spinner animation="border" role="status" aria-label="Loading charities" />
        </div>
      ) : charities.length === 0 ? (
        <p className="text-center text-muted py-5">No charities to display right now.</p>
      ) : (
      <Row xs={1} md={2} className="g-4">
        {charities.map((charity) => {
          const { name, url, description, logoUrl, category } = charity.data
          return (
            <Col key={charity.id}>
              <Card className="h-100 border-0 shadow-sm">
                <Card.Body className="d-flex flex-column p-4">
                  {logoUrl && (
                    <img
                      src={logoUrl}
                      alt={name}
                      className="mb-3"
                      style={{ maxHeight: '48px', objectFit: 'contain', alignSelf: 'flex-start' }}
                    />
                  )}
                  <div className="mb-2">
                    <Badge bg={categoryColor(category)} className="fw-normal">
                      {category}
                    </Badge>
                  </div>
                  <Card.Title as="h3" className="fs-5 fw-bold mb-2">
                    {name}
                  </Card.Title>
                  <Card.Text className="text-muted flex-grow-1" style={{ lineHeight: '1.6' }}>
                    {description}
                  </Card.Text>
                  <a
                    href={url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-outline-secondary btn-sm mt-3 align-self-start"
                  >
                    Visit {name}{' '}
                    <svg
                      aria-label="external link"
                      xmlns="http://www.w3.org/2000/svg"
                      width="12"
                      height="12"
                      fill="currentColor"
                      viewBox="0 0 16 16"
                    >
                      <path fillRule="evenodd" d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5z" />
                      <path fillRule="evenodd" d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0v-5z" />
                    </svg>
                  </a>
                </Card.Body>
              </Card>
            </Col>
          )
        })}
      </Row>
      )}
    </section>
  )
}

export default CharityList
